import { defineStore } from 'pinia'

export const useTravelDatesStore = defineStore('travel_dates', {
  state: () => ({
    arrival: '',
    departure: ''
  }),
  getters: {
    isComplete: state => state.arrival && state.departure
  }
})
